/** Screens that normalize multi-ID IN search values. */
export const IN_MULTI_VALUE_TABLE_IDS = new Set([
  'shpmtsearchtd', // Shipment Planning
  'shipmtfinalizedtd', // Finalized Shipment
  'shpmtsearchEX', // Shipment Execution
  'shpmtAddPack', // Enroute Dispatch
]);

/** Search columns that accept space/newline-separated multi values for IN. */
export const IN_MULTI_VALUE_COLUMNS = new Set([
  'customer ref no',
  'client ref no',
  'order id',
  'order release xid',
  'order reference id',
  'order source id',
  'shipment id',
]);

/**
 * Same behavior as Carrier Booking Dashboard multi Shipment ID search:
 * trim, split on newlines/commas/spaces, de-dupe, join with commas.
 */
export function normalizeInSearchValue(value?: string | null): string {
  if (value == null) {
    return '';
  }
  const normalized = value.split('\r\n').join('\n').trim();
  if (!normalized) {
    return '';
  }
  const tokens = normalized
    .split(/[\s,]+/)
    .map(token => token.trim())
    .filter(token => !!token);
  return Array.from(new Set(tokens)).join(',');
}

export function shouldNormalizeInSearchValue(
  tableId: string | undefined | null,
  column: string | undefined | null,
  operation: string | undefined | null
): boolean {
  if (!tableId || !column || !operation) {
    return false;
  }
  if (!IN_MULTI_VALUE_TABLE_IDS.has(tableId)) {
    return false;
  }
  if (String(operation).toUpperCase() !== 'IN') {
    return false;
  }
  return IN_MULTI_VALUE_COLUMNS.has(String(column).trim().toLowerCase());
}
